import {UserModel} from './user.model';

export interface TokenModel {
    access_token: string;
    user: UserModel;
}
